import { createContext, useContext, useState } from 'react';

const EnquiryContext = createContext({ open: () => {} });

export const EnquiryProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefillType, setPrefillType] = useState(null);
  const open = (type = null) => {
    setPrefillType(type);
    setIsOpen(true);
  };
  return (
    <EnquiryContext.Provider value={{ isOpen, open, close: () => setIsOpen(false), prefillType }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
